module.exports = __webpack_public_path__ + "img/001.a3180dc3.jpg";